<template>
  <div class="slideSwitchSelect" ref="slideSwitchSelect" :data-content="slideSwitchSelect.content"
       :style="{'--left':slideSwitchSelect.left+'px','--width':slideSwitchSelect.width+'px','--top':slideSwitchSelect.top+'%'}">
    <div v-for="(item,index) in slideSwitchList" :key="index" @click="change(item)">{{ item.content }}</div>
  </div>
</template>

<script>
export default {
  name: "mSlideSwitch",
  props: {
    slideSwitchList: {
      type: Array,
      default: () => ([{
        content: '最近6个月',
        month: '6'
      }, {
        content: '最近9个月',
        month: '9'
      }, {
        content: '最近12个月',
        month: '12'
      }])
    },
    hiddenStatus: {
      type: Number,
    }
  },
  watch: {
    hiddenStatus() {
      this.slideSwitchSelect.top = -105
    }
  },
  data() {
    return {
      slideSwitchSelect: {
        top: 0,
        left: 0,
        content: '',
        width: ''
      },
      currentChildren: {}
    }
  },
  mounted() {
    this.initFun(true)
    window.addEventListener('resize', () => this.setSlideSwitchSelect())
  },
  methods: {
    initFun(isDefault) {
      const slideSwitchSelect = this.$refs.slideSwitchSelect;
      const childrenList = [...slideSwitchSelect.children];
      const children = childrenList[1]
      this.slideSwitchSelect.width = children.offsetWidth
      this.slideSwitchSelect.left = children.offsetLeft
      childrenList.forEach(children => {
        children.onclick = ev => {
          this.currentChildren = children
          this.setSlideSwitchSelect()
        }
      })
      isDefault && children.click()
    },
    setSlideSwitchSelect() {
      this.slideSwitchSelect.left = this.currentChildren.offsetLeft
      this.slideSwitchSelect.top = 0
      this.slideSwitchSelect.width = this.currentChildren.offsetWidth
      this.slideSwitchSelect.content = this.currentChildren.innerText
    },
    change(item) {
      this.$emit('change', item)
    }
  }
}
</script>

<style scoped lang="scss">
.slideSwitchSelect {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  font-size: calc(0.12 * var(--fontSize));
  position: relative;
  justify-items: center;
  align-content: center;
  overflow: hidden;
  box-sizing: border-box;

  border-radius: calc(1.61 * var(--fontSize));
  background: linear-gradient(180deg, rgba(243, 245, 247, 1) 0%, rgba(243, 245, 247, 1) 9.91%, rgba(242, 245, 247, 1) 100%);
  border: 1px solid rgba(255, 255, 255, 1);
  box-shadow: inset -6px -6px 15px 0px rgba(255, 255, 255, 1), inset 4px 4px 13px 0px rgba(222, 221, 227, 0.28);

  & > div {
    width: 100%;
    cursor: pointer;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:before {
    position: absolute;
    content: attr(data-content);
    height: 100%;
    width: var(--width);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 1;
    top: var(--top);
    left: var(--left);
    border-radius: calc(0.235 * var(--fontSize));
    background: rgba(88, 159, 248, 1);
    border: 1px solid rgba(255, 255, 255, 1);
    box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, 0.8), 7px 7px 20px 0px rgba(222, 221, 227, 1);
    transition: .5s;
    box-sizing: border-box;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mSlideSwitch.vue